import GroupIcon from "@mui/icons-material/Group";
import ListIntermediaries from "./List";
import { INTERMEDIARIES, AdministrationServicePath } from "utils/constants";
import EditIntermediaries from "./Edit";
import CreateIntermediaries from "./Create";
import permissions from "app/permissions";
import { tenants } from "utils/tenants";

//permissions
export const resources = {
  isMenu: true,
  tenancies: [tenants.MU],
  icon: <GroupIcon />,
  name: AdministrationServicePath + INTERMEDIARIES,
  title: "Представители",
  list: <ListIntermediaries />,
  create: <CreateIntermediaries />,
  createPermission: permissions.canCreateIntermediaries,
  edit: <EditIntermediaries />,
  editPermission: permissions.canUpdateIntermediaries,
  permission: permissions.canPreviewIntermediaries,
};
